<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "SelectRampAvailability" });
import { SelectSingle } from "../../../../selects/index.js";
export let key;
export let isDisabled = false;
export let isRequired = false;
const OPTIONS = [{ key: "available", label: "Yes" }, { key: "unavailable", label: "No" }, { key: "unknown", label: "Unknown" }];
</script>

<SelectSingle
    bind:key
    label = 'Ramp Available'
    placeholder = 'Select Option'
    name = 'address.rampAvailabilityCode'
    options = { OPTIONS }
    { isDisabled }
    { isRequired }
/>